import { monthAndDay as monthAndDayFormat } from '@/helpers/dateTimeFormats';

const monthAndDayFormatter = new Intl.DateTimeFormat(undefined, monthAndDayFormat);

export default function formatMonthAndDay(dateTime) {
  if (!dateTime) return '';
  return monthAndDayFormatter.format(dateTime);
}
